module.exports = __webpack_public_path__ + "static/media/592JamesPBrawleyDrNW_2018-06-12_181.26c6c90f.jpg";